// Imports ------------------------------------------------------------------->

import { Service, service, inject } from './di'
import { ConfigService, RuntimeConfig } from './ConfigService'

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

@service
export class UserAgentService extends Service {
    @inject config: ConfigService

    android = /Android/.test(navigator.userAgent)
    iOS = /iPhone|iPad|iPod/.test(navigator.userAgent)
    ie = /MSIE|Trident/.test(navigator.userAgent)
    firefox = /Firefox|FxiOS/.test(navigator.userAgent)
    chrome = /Chrome|CriOS/.test(navigator.userAgent)

    get mobile() {
        return (
            this.android ||
            this.iOS ||
            // Firefox OS
            (this.firefox && /Mobile|Tablet|TV/.test(navigator.userAgent))
        )
    }

    get safari() {
        return (
            /Safari/.test(navigator.userAgent) &&
            // Firefox & Chrome on iOS report Safari, since they use UIWebView
            !this.firefox &&
            !this.chrome
        )
    }

    getAppLinkHref() {
        const appLink = 'https://click.flipp.com/h8pE/87rdp54h'
        if (this.config.RUNTIME === RuntimeConfig.DISTRIBUTION) {
            return appLink
        }

        if (this.android) {
            return this.getAndroidAppLink()
        } else if (this.iOS) {
            return this.iosAppLink()
        } else {
            return appLink
        }
    }

    iosAppLink() {
        return 'https://flipp.app.link/KYJFGWvFo1'
    }

    getAndroidAppLink() {
        return 'https://flipp.app.link/KYJFGWvFo1'
    }
}
